import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bi bi-box-arrow-in-right"
}
const _hoisted_2 = {
  key: 1,
  class: "bi bi-box-arrow-right"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: "btn bg-secondary border-0 bg-opacity-05 d-flex align-items-center justify-content-center gap-2 py-2 px-4",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.authorizedContinue()))
  }, [
    _createTextVNode(_toDisplayString(_ctx.$t(`app.${_ctx.isAutorized ? "onLogout" : "onLogin"}`)) + " ", 1),
    (!_ctx.isAutorized)
      ? (_openBlock(), _createElementBlock("i", _hoisted_1))
      : (_openBlock(), _createElementBlock("i", _hoisted_2))
  ]))
}